/* TK product cards (snippets/grid-view-item.liquid, snippets/tk-variant-links.liquid, snippets/tk-card-video.liquid)
   Loaded once per page from layout/theme.liquid, so cards added later (infinite scroll, recommendations fetched
   by script) work too.
   1. "+" size picker: one delegated listener, so cards added by infinite scroll work without re-binding.
      TK: a plain click on an in-stock size (a[data-tk-add]) adds it to the bag, the same way assets/tk-product.js
      addToBag does (bag drawer updated and opened, bag count refreshed); sold-out sizes keep opening Amp's
      back-in-stock form (BIS_trigger, not touched here). Ctrl/cmd/shift/middle-click still opens the product page.
   2. In-view card videos: a <video> exists only while its card is on screen, and at most MAX_ACTIVE at once.
      Leaving the screen pauses it, drops its source and removes it from the page, so memory stays flat
      however far infinite scroll goes.
   3. Card photos (data-tk-gallery = the product's other photos, space separated), Jaded-style:
      - Desktop: hovering a card fades in photo 2; moving the mouse off goes back to photo 1.
      - Phones / touch: one arrow on the right. Tapping it shows the next photo; after that both arrows show (they loop).
        Tapping an arrow never opens the product. No dots and no swiping inside the card (the page scrolls normally).
      - A photo only appears once it has fully loaded, so there is never a grey or half-drawn frame.
      - Desktop, like jadedldn.com: photo 2 of the cards on and near the screen downloads with the page (low priority,
        so the cards' own photos still come first), so hovering switches straight away, even before the page has
        finished loading. Cards further down get theirs as they come near. Phones: a photo is fetched only when its
        arrow is tapped. A card that scrolls far away goes back to its own single photo, so memory stays flat with
        any number of products. */
if (!window.__tkCard) {
  window.__tkCard = true;

  /* ---------- Size picker ---------- */
  let openQuick = null;

  const setOpen = (quick, open) => {
    const btn = quick.querySelector('.tk-quick__toggle');
    quick.classList.toggle('is-open', open);
    if (btn) {
      btn.setAttribute('aria-expanded', String(open));
      const label = open ? btn.dataset.labelClose : btn.dataset.labelOpen;
      if (label) btn.setAttribute('aria-label', label);
    }
    if (open) openQuick = quick;
    else if (openQuick === quick) openQuick = null;
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.tk-quick__toggle');
    if (btn) {
      event.preventDefault();
      event.stopPropagation();
      const quick = btn.closest('.tk-quick');
      const willOpen = !quick.classList.contains('is-open');
      if (openQuick && openQuick !== quick) setOpen(openQuick, false);
      setOpen(quick, willOpen);
      return;
    }
    if (openQuick && !openQuick.contains(event.target)) setOpen(openQuick, false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !openQuick) return;
    const btn = openQuick.querySelector('.tk-quick__toggle');
    setOpen(openQuick, false);
    if (btn) btn.focus();
  });

  /* ---------- Size picker: add to bag ----------
     TK: in-stock sizes add straight to the bag instead of opening the product page. Capture phase on document, so the
     click is handled (and stopped) before any card-level handler sees it; Amp's BIS_trigger links have no data-tk-add
     and are left alone. Busy/error styles are injected once here (the picker's main CSS is in tk-shop-blocks.css). */
  const ADD_ERROR = "Couldn't add to bag. Please try again.";
  const shopRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const addStyle = document.createElement('style');
  addStyle.setAttribute('data-tk-quick-add', '');
  addStyle.textContent = `
.tk-quick a.tk-variant[aria-busy="true"]{opacity:.35;pointer-events:none;cursor:progress;text-decoration:none}
.tk-quick__msg{flex-basis:100%;margin:6px 0 0;font-size:11px;line-height:1.4;letter-spacing:.04em;text-transform:none;color:#8b1a2b}
`;
  document.head.appendChild(addStyle);

  const showMsg = (quick, text) => {
    const panel = quick && quick.querySelector('.tk-quick__panel');
    if (!panel) return;
    let msg = panel.querySelector('.tk-quick__msg');
    if (!text) { if (msg) msg.remove(); return; }
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'tk-quick__msg';
      msg.setAttribute('role', 'alert');
      panel.appendChild(msg);
    }
    msg.textContent = text;
    clearTimeout(msg._t);
    msg._t = setTimeout(() => { if (msg.isConnected) msg.remove(); }, 5000);
  };

  const addSize = async (link) => {
    const id = Number(link.getAttribute('data-tk-add'));
    const quick = link.closest('.tk-quick');
    if (!id || link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    showMsg(quick, '');

    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id, quantity: 1 }] };
    if (drawer) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      // Read as text first: an HTML error page must not surface as a JSON parse error.
      const text = await res.text();
      let json = null;
      try { json = text ? JSON.parse(text) : null; } catch (e) { json = null; }
      if (!res.ok || !json) {
        const err = new Error((json && (json.description || json.message)) || ADD_ERROR);
        err.tkFriendly = true;
        throw err;
      }

      if (window.eventBus) {
        if (drawer) window.eventBus.emit('update:cart:drawer', json);
        window.eventBus.emit('cart:added', json);
      }
      // The item is in the bag already; a failed count refresh must not show an error.
      try {
        const cart = await (await fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' })).json();
        if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
      } catch (e) {}

      if (quick) setOpen(quick, false);
      if (drawer && window.eventBus) window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      else if (!drawer) window.location.href = shopRoot() + 'cart';
    } catch (err) {
      showMsg(quick, err && err.tkFriendly && err.message ? err.message : ADD_ERROR);
    } finally {
      link.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('.tk-quick a[data-tk-add]');
    if (!link || link.classList.contains('BIS_trigger')) return;
    // New tab / window / download: let the browser follow the link to the product page.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    addSize(link);
  }, true);

  /* ---------- In-view videos ---------- */
  const MAX_ACTIVE = 4;
  const active = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = !!(navigator.connection && navigator.connection.saveData);

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const el = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) el.start();
      else if (entry.intersectionRatio < 0.1) el.stop();
    }
  }, { threshold: [0, 0.1, 0.5] });

  class TkCardVideo extends HTMLElement {
    connectedCallback() {
      if (reducedMotion.matches || saveData) return;
      observer.observe(this);
    }

    disconnectedCallback() {
      observer.unobserve(this);
      this.stop();
    }

    pickSource(video) {
      // Native HLS (Safari / iOS) starts small and adapts; everything else gets the mp4.
      if (this.dataset.hls && video.canPlayType('application/vnd.apple.mpegurl')) return this.dataset.hls;
      return this.dataset.src || '';
    }

    start() {
      if (document.hidden) return;
      if (this.video) {
        this.video.play().catch(() => {});
        return;
      }
      if (active.size >= MAX_ACTIVE) active.values().next().value.stop(); // oldest one makes room

      const video = document.createElement('video');
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.autoplay = true;
      video.preload = 'auto';
      video.disablePictureInPicture = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('disableremoteplayback', '');
      video.setAttribute('aria-hidden', 'true');
      video.tabIndex = -1;
      video.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
      video.addEventListener('error', () => this.stop(), { once: true });
      const src = this.pickSource(video);
      if (!src) return;
      video.src = src;

      this.video = video;
      active.add(this);
      this.appendChild(video);
      video.play().catch(() => {});
    }

    stop() {
      const video = this.video;
      if (!video) return;
      this.video = null;
      active.delete(this);
      this.classList.remove('is-playing');
      video.pause();
      video.removeAttribute('src');
      video.load(); // releases the decoder and buffered frames
      video.remove();
    }
  }

  if (!customElements.get('tk-card-video')) customElements.define('tk-card-video', TkCardVideo);

  // Background tab: free everything; the observer restarts what is on screen when the tab comes back.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      [...active].forEach((el) => el.stop());
    } else {
      document.querySelectorAll('tk-card-video').forEach((el) => {
        observer.unobserve(el);
        if (!reducedMotion.matches && !saveData) observer.observe(el);
      });
    }
  });

  /* ---------- Card photos ---------- */
  const GAL_MAX = 8; // the card's own photo + up to 7 more (snippets/grid-view-item.liquid sends at most 7)
  const touchUI = window.matchMedia('(hover: none), (pointer: coarse)');
  const WIDTHS = [360, 540, 720, 900, 1080];

  const css = `
.tk-gal{position:absolute;inset:0;z-index:2;pointer-events:none}
.tk-gal__img{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover;object-position:center;opacity:0;transition:opacity .35s ease}
.tk-gal__img.is-on{opacity:1}
.tk-gal__arrow{position:absolute;top:50%;z-index:3;display:flex;align-items:center;justify-content:center;width:40px;height:48px;margin:-24px 0 0;padding:0;border:0;border-radius:0;background:none;box-shadow:none;color:#000;cursor:pointer;pointer-events:auto;-webkit-tap-highlight-color:transparent;-webkit-appearance:none;appearance:none;filter:drop-shadow(0 0 1px rgba(255,255,255,.9)) drop-shadow(0 0 2px rgba(255,255,255,.5));transition:opacity .2s ease}
.tk-gal__arrow--next{right:0}
.tk-gal__arrow--prev{left:0;visibility:hidden}
.tk-gal.is-moved .tk-gal__arrow--prev{visibility:visible}
.tk-gal__arrow svg{display:block;width:16px;height:16px}
.tk-gal__arrow[aria-busy="true"]{opacity:.45}
[data-tk-cols="8"] .tk-gal__arrow{display:none}
@media (max-width:989px){[data-tk-cols-m="4"] .tk-gal__arrow{display:none}}
@media (prefers-reduced-motion:reduce){.tk-gal__img{transition:none}}
`;
  const style = document.createElement('style');
  style.setAttribute('data-tk-gal', '');
  style.textContent = css;
  document.head.appendChild(style);

  const CHEVRON = (d) => '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="' + d + '"/></svg>';

  const sized = (url, el) => {
    const w = (el.clientWidth || 300) * Math.min(window.devicePixelRatio || 1, 2);
    const pick = WIDTHS.find((x) => x >= w) || WIDTHS[WIDTHS.length - 1];
    return url.replace(/([?&])width=\d+/, '$1width=' + pick);
  };

  const urlsOf = (link) => (link.getAttribute('data-tk-gallery') || '').split(/\s+/).filter(Boolean).slice(0, GAL_MAX - 1);

  const build = (link) => {
    if (link._gal) return link._gal;
    const urls = urlsOf(link);
    if (!urls.length) return null;
    const gal = document.createElement('div');
    gal.className = 'tk-gal';
    gal._urls = urls;
    gal._i = 0;    // photo on screen (0 = the card's own photo)
    gal._want = 0; // photo asked for (may still be loading)
    gal._cache = {};
    const img = document.createElement('img');
    img.className = 'tk-gal__img';
    img.alt = '';
    img.decoding = 'async';
    img.setAttribute('aria-hidden', 'true');
    gal.appendChild(img);
    gal._img = img;
    if (touchUI.matches) {
      const mk = (dir, label, d) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'tk-gal__arrow tk-gal__arrow--' + dir;
        b.tabIndex = -1; // the card link itself is not in the tab order either; keyboard users get the product page
        b.setAttribute('aria-label', label);
        b.innerHTML = CHEVRON(d);
        gal.appendChild(b);
        return b;
      };
      mk('prev', 'Previous photo', 'M10 3 5 8l5 5');
      gal._next = mk('next', 'Next photo', 'M6 3l5 5-5 5');
    }
    link.appendChild(gal);
    link._gal = gal;
    return gal;
  };

  const destroy = (link) => {
    const gal = link._gal;
    if (!gal) return;
    link._gal = null;
    gal._want = -1;
    gal._img.removeAttribute('src');
    Object.keys(gal._cache).forEach((k) => { gal._cache[k].onload = gal._cache[k].onerror = null; gal._cache[k].removeAttribute('src'); });
    gal.remove();
  };

  // Desktop: fetch photo 2 ahead of the hover (low priority, so the cards' own photos win the bandwidth)
  const prefetch = (link) => {
    if (touchUI.matches) return;
    const gal = build(link);
    if (!gal || gal._cache[1]) return;
    const im = new Image();
    im.decoding = 'async';
    try { im.fetchPriority = 'low'; } catch (e) {}
    gal._cache[1] = im;
    im.src = sized(gal._urls[0], link);
  };

  const busy = (gal, on) => { if (gal._next) gal._next.setAttribute('aria-busy', on ? 'true' : 'false'); };

  // Shows photo i (0 = the card's own photo) once it has loaded and decoded; until then the current photo stays.
  const show = (gal, i, link) => {
    gal._want = i;
    if (i === 0) {
      gal._i = 0;
      busy(gal, false);
      gal._img.classList.remove('is-on');
      return;
    }
    let im = gal._cache[i];
    if (!im) {
      im = new Image();
      im.decoding = 'async';
      gal._cache[i] = im;
      im.src = sized(gal._urls[i - 1], link);
    }
    const done = () => {
      if (gal._want !== i || !gal.isConnected) return;
      busy(gal, false);
      gal._img.src = im.src;
      gal._img.classList.add('is-on');
      gal._i = i;
    };
    if (im.complete && im.naturalWidth) { done(); return; }
    busy(gal, true);
    // decode() first so the photo appears whole; capped at 300ms because some browsers never settle it for
    // off-screen or background tabs
    im.onload = () => {
      const p = im.decode ? Promise.race([im.decode().catch(() => {}), new Promise((r) => setTimeout(r, 300))]) : Promise.resolve();
      p.then(done);
    };
    im.onerror = () => {
      if (gal._want !== i) return;
      busy(gal, false);
      gal._want = gal._i; // stay on the photo that is showing
      delete gal._cache[i];
    };
  };

  /* Phones / touch: arrows. Capture phase, so the tap never reaches the card link or the theme's card scripts. */
  const onArrow = (event) => {
    const arrow = event.target.closest && event.target.closest('.tk-gal__arrow');
    if (!arrow) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.type !== 'click') return;
    const gal = arrow.closest('.tk-gal');
    const link = gal && gal.parentElement;
    if (!gal || !link) return;
    const n = gal._urls.length + 1;
    const from = gal._want >= 0 ? gal._want : gal._i;
    const to = arrow.classList.contains('tk-gal__arrow--next') ? (from + 1) % n : (from - 1 + n) % n;
    gal.classList.add('is-moved');
    show(gal, to, link);
  };
  document.addEventListener('click', onArrow, true);
  document.addEventListener('touchend', (event) => {
    // Some card scripts act on touchend; keep them off the arrows (the click that follows still runs onArrow).
    if (event.target.closest && event.target.closest('.tk-gal__arrow')) event.stopPropagation();
  }, true);

  /* Desktop: hover = photo 2, mouse out = photo 1. Works as soon as the card is on the page. */
  // The hover area is the whole card (photo, the + picker that sits on it, title and price), not just the photo link.
  let hoverLink = null;
  let hoverZone = null;
  const zoneOf = (el) => {
    if (!el || !el.closest) return null;
    const card = el.closest('.grid-view-item');
    if (card) return card.querySelector('[data-tk-gallery]') ? card : null;
    return el.closest('[data-tk-gallery]');
  };
  const hoverOn = (link) => {
    if (touchUI.matches) return;
    const gal = build(link);
    if (gal) show(gal, 1, link);
  };
  const hoverOff = () => {
    if (hoverLink && hoverLink._gal) show(hoverLink._gal, 0, hoverLink);
    hoverLink = hoverZone = null;
  };
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const zone = zoneOf(event.target);
    if (zone === hoverZone) return;
    hoverOff();
    if (!zone) return;
    hoverZone = zone;
    hoverLink = zone.matches('[data-tk-gallery]') ? zone : zone.querySelector('[data-tk-gallery]');
    if (hoverLink) hoverOn(hoverLink);
  });
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || !hoverZone) return;
    const to = event.relatedTarget;
    if (to && hoverZone.contains(to)) return;
    hoverOff();
  });

  /* Cards near the screen: phones get their arrows (no downloads, just two buttons); desktop fetches photo 2.
     Far away = back to one photo. */
  const galObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) { if (touchUI.matches) build(entry.target); }
      else destroy(entry.target);
    }
  }, { rootMargin: '100% 0px 100% 0px' });
  // Desktop photo 2: only cards on screen or within half a screen below, so a long grid doesn't fetch dozens at once
  const prefetchObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) if (entry.isIntersecting) prefetch(entry.target);
  }, { rootMargin: '0px 0px 50% 0px' });

  const watchGalleries = (root) => {
    (root || document).querySelectorAll('[data-tk-gallery]:not([data-tk-gal-watch])').forEach((link) => {
      link.setAttribute('data-tk-gal-watch', '');
      galObserver.observe(link);
      prefetchObserver.observe(link);
    });
  };
  const unwatch = (node) => {
    const links = node.matches && node.matches('[data-tk-gal-watch]') ? [node] : node.querySelectorAll ? node.querySelectorAll('[data-tk-gal-watch]') : [];
    links.forEach((link) => { galObserver.unobserve(link); prefetchObserver.unobserve(link); destroy(link); });
  };

  let scanQueued = false;
  const queueScan = () => {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(() => { scanQueued = false; watchGalleries(); }, 50);
  };
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) if (node.nodeType === 1 && !(node.classList && node.classList.contains('tk-gal'))) { queueScan(); break; }
      for (const node of m.removedNodes) if (node.nodeType === 1 && !(node.classList && node.classList.contains('tk-gal'))) unwatch(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watchGalleries());
  else watchGalleries();
  // Switching between touch and mouse (tablet with a mouse, devtools): rebuild in the right mode.
  touchUI.addEventListener && touchUI.addEventListener('change', () => {
    document.querySelectorAll('[data-tk-gal-watch]').forEach((link) => destroy(link));
    hoverLink = hoverZone = null;
    document.querySelectorAll('[data-tk-gal-watch]').forEach((link) => {
      galObserver.unobserve(link); galObserver.observe(link);
      prefetchObserver.unobserve(link); prefetchObserver.observe(link);
    });
  });
}
